export default {"src":"/_next/static/media/img34.d5de52d9.svg","height":543,"width":1398,"blurWidth":0,"blurHeight":0};